import * as React from 'react';
import { Config } from './Config';
import { FormPost } from './Helpers/FormPost';
import { MainHandler } from './MainHandler';
import { Candidate } from './Model/Candidate';
import { JobCenterModelInterface } from './Model/JobCenterModelInterface';
import { JobVacancy } from './Model/JobVacancy';
import { ReferenceIdContainerInterface } from './ReferenceIdContainer';
import { LocalizationUtility } from './Service/LocalizationUtility';
import { UriBuilder } from './Service/UriBuilder';
import { ServiceLocator } from './ServiceLocator';
import { Type } from './Type';

export class AppContext<M extends Candidate | JobVacancy | JobCenterModelInterface = JobCenterModelInterface> {
    public readonly serviceLocator: ServiceLocator;
    public readonly handler: MainHandler<M>;
    public readonly i18n: LocalizationUtility;
    public readonly config: Config;

    constructor(serviceLocator: ServiceLocator, handler: MainHandler<M>, i18n: LocalizationUtility, config?: Config) {
        this.i18n = i18n;
        this.serviceLocator = serviceLocator;
        this.handler = handler;
        this.config = config || serviceLocator.get('config');
    }

    get basePath(): string {
        return this.config.basePath;
    }

    get selectedJobVacancies(): ReferenceIdContainerInterface {
        return this.handler.state.selectedJobVacancies;
    }

    get twoLetterIsoCode(): string {
        return this.config.twoLetterIsoCode;
    }

    /**
     * Return the reference ID of the department of which the objects should be fetched
     *
     * @return {string}
     */
    get departmentId(): string {
        return this.config.departmentId;
    }

    public applyTo(input: JobVacancy): void;
    public applyTo(input: ReferenceIdContainerInterface): void;
    public applyTo(input: ReferenceIdContainerInterface | JobVacancy): void {
        let refids;
        if (input instanceof JobVacancy) {
            refids = input.referenceId;
        } else if (typeof input.identifiers !== 'undefined') {
            refids = input.identifiers.join(',');
        } else {
            throw new TypeError(`Expected argument "input" to be a JobVacancy or ReferenceIdContainerInterface. '${typeof input}' given`);
        }

        const uriBuilder = new UriBuilder(this.config);

        FormPost.post(uriBuilder.formUriForType(Type.JobVacancy), {refids});
    }

    public requestProfile(input: Candidate): void;
    public requestProfile(input: ReferenceIdContainerInterface): void;
    public requestProfile(input: ReferenceIdContainerInterface | Candidate): void {
        let refids;
        if (input instanceof Candidate) {
            refids = input.referenceId;
        } else if (typeof input.identifiers !== 'undefined') {
            refids = input.identifiers.join(',');
        } else {
            throw new TypeError(`Expected argument "input" to be a Candidate or ReferenceIdContainerInterface. '${typeof input}' given`);
        }

        const uriBuilder = new UriBuilder(this.config);

        FormPost.post(uriBuilder.formUriForType(Type.Candidate), {refids});
    }

}

export const AppContextType = React.createContext((null as any) as AppContext<any>);
